$(function () {
  $("#MenuTrigger").on("click", function () {
    $(this).toggleClass("active");
    $("#Navigation").slideToggle(500);
    return false;
  });
});
